var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mockup-preview-video",style:(_vm.style)},[(!!_vm.current.src)?_c('video',{ref:"previewVideo",attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.current.src,"type":"video/mp4"}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }